enum ProposalType {
  Zapper = 'Zapper',
  Streamer = 'Streamer',
  AltijdAlles = 'AltijdAlles',
}

export default ProposalType;
